import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "lib/api";
import { useDashboardSettings } from "../settings/store";

const JSON_HEADERS = { "Content-Type": "application/json" };

function jsonRequest(method, payload) {
  if (payload === undefined) return { method };
  return { method, body: JSON.stringify(payload), headers: JSON_HEADERS };
}

const tagsKeys = {
  all(periodoId) {
    return ["dashboard", "tags", { periodoId }];
  },
  detail(periodoId, tagId) {
    return ["dashboard", "tags", "detail", { periodoId, tagId }];
  },
};

export function useDashboardTags() {
  const s = useDashboardSettings();
  return useQuery({
    queryKey: tagsKeys.all(s.periodoId),
    queryFn: () => api("/dashboard/club/tags", {}, { periodoId: s.periodoId }),
    enabled: !!s.periodoId,
  });
}

export function useDashboardTag(tagId) {
  const s = useDashboardSettings();
  return useQuery({
    queryKey: tagsKeys.detail(s.periodoId, tagId),
    queryFn: () => api(`/dashboard/club/tags/${tagId}`, {}, { periodoId: s.periodoId }),
    enabled: !!s.periodoId && !!tagId,
  });
}

export function useCreateDashboardTag() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (nombre) =>
      api("/dashboard/club/tags", jsonRequest("POST", { nombre }), { periodoId: s.periodoId }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dashboard", "tags"] }),
  });
}

export function usePatchDashboardTag() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ tagId, patch }) =>
      api(`/dashboard/club/tags/${tagId}`, jsonRequest("PATCH", patch), { periodoId: s.periodoId }),
    onSuccess: (_data, variables) =>
      Promise.all([
        qc.invalidateQueries({ queryKey: ["dashboard", "tags"] }),
        qc.invalidateQueries({ queryKey: tagsKeys.detail(s.periodoId, variables.tagId) }),
      ]),
  });
}

export function useDeleteDashboardTag() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (tagId) =>
      api(`/dashboard/club/tags/${tagId}`, { method: "DELETE" }, { periodoId: s.periodoId }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dashboard", "tags"] }),
  });
}
